import { SET_DSR_ZOOM_LINK_IS_ACTIVE } from '../actions/dsr-actions-types';

const INITIAL_STATE_SET_DSR_ZOOM_LINK_IS_ACTIVE = { results: '' }

export function setDsrZoomLinkIsActiveReducer(state = INITIAL_STATE_SET_DSR_ZOOM_LINK_IS_ACTIVE, action) {
    switch (action.type) {
        case SET_DSR_ZOOM_LINK_IS_ACTIVE:
            return { results: action.payload }
        default:
            return state;
    }
}